import { dynamicPx } from 'components/common/Common';
import styled, { css } from 'styled-components';

export const TableWrapper = styled.div`
  position: relative;
  width: 100%;
  border: 1.6px solid #a6c0cf;
  border-radius: 1em;
  overflow: auto;
  @media (max-width: 768px) {
    ${(props) =>
      props.responsive
        ? css`
            border: 0;
            overflow: hidden;
          `
        : css``};
  }
`;

export const TableContent = styled.div`
  width: 100%;
  overflow: auto;
  line-height: 1.2;
`;

export const StyledTable = styled.table`
  border-spacing: 0;
  border-collapse: collapse;
  border-style: hidden;
  width: 100%;
  max-width: 100%;

  & td,
  & th {
    text-align: center;
    padding: 1.2em;
  }

  & th {
    background-color: #eff6fa;
  }

  & td {
    border-top: 1.6px solid var(--table-border-color);
    border-bottom: 1.6px solid var(--table-border-color);
  }

  ${({ $sticky }) => {
    return $sticky.reduce((styleString, pos) => {
      /* Force table to be sticky based on position */
      const stickyStyle = css`
        position: -webkit-sticky;
        left: 0;
        position: sticky;
        color: #fff;
        font-size: 14px;
      `;
      return (styleString += `
            th:nth-of-type(${pos + 1}) {
              ${stickyStyle}
              background-color: #eff6fa;
            }
            td:nth-of-type(${pos + 1}) {
              ${stickyStyle}
              background-color: #fff;
            }
        `);
    }, ``);
  }}

  @media (max-width: 768px) {
    ${(props) =>
      props.responsive
        ? css`
            /* Force table to not be like tables anymore */
            table,
            thead,
            tbody,
            th,
            td,
            tr {
              display: block;
            }

            /* Hide table headers (but not display: none;, for accessibility) */
            thead tr {
              position: absolute;
              top: -9999px;
              left: -9999px;
            }

            tr {
              border: 1.6px solid var(--table-border-color);
              border-radius: 1em;
              margin: 0.625em 0;
              & > td:not(:last-child) {
                border-bottom: 1px solid var(--table-border-color);
              }
              td:last-child {
                border-bottom-left-radius: 1em;
                border-bottom-right-radius: 1em;
              }
              td:first-child {
                border-top-left-radius: 1em;
                border-top-right-radius: 1em;
              }
            }

            td {
              /* Behave  like a "row" */
              border: none;
              position: relative;
              padding-left: 50%;

              &:hover {
                background-color: #eff6fa;
              }
            }

            td:before {
              /* Now like a table header */
              position: absolute;
              /* Top/left values mimic padding */
              top: 0.5em;
              left: 0.5em;
              width: 45%;
              padding: 0.5em;
              font-size: ${dynamicPx({ minSize: 12, maxSize: 18 })};
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            /*
            Label the data
            */
            ${({ header }) => {
              let templateLiteral = ``;
              header.forEach((info, i) => {
                templateLiteral += `
                  td:nth-of-type(${i + 1}):hover::after {
                    content: "${info}";
                    position: absolute;
                    left: 10px;
                    top: 30px;
                    padding: .5em;
                    background: rgba(57, 57, 57,.7);
                    color: #fff;
                    font-size: 14px;
                    white-space: nowrap;
                    border-radius: 1em;
                  }
                  td:nth-of-type(${i + 1}):before {
                      content: "${info}";
                  };
              `;
              });
              return templateLiteral;
            }}
          `
        : css``};
  }
`;
